// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3feW4","location":"Header_location__8kCKY"};